import { gql } from "graphql-request";
import { requestAndFormat } from "../utils";

export const createUpdateMutation = (params: {
	itemId: string;
	body: string;
	mentionList?: Array<unknown>;
}) =>
	requestAndFormat(
		{
			defaultParams: {
				mentionList: [],
			},
			gql: gql`
				mutation CreateUpdate(
					$itemId: ID!,
					$body: String!
					$mentionList: [UpdateMention!],
				) {
					create_update(
						item_id: $itemId,
						body: $body,
						mentions_list: $mentionList
					) {
						id
					}
				}`,
			skipMondayFormatting: true,
			resultKey: "create_update",
			outType: {} as { id: string },
		},
		params,
	);
